// extracted by mini-css-extract-plugin
export default {"visually_hidden":"TrueFalse_visually_hidden__omXpK","iconWrap":"TrueFalse_iconWrap__iLk5G"};